import { makeAutoObservable } from "mobx";
export interface PayType {
	id: number;
	name: string;
	isActive: boolean;
}

export class PayTypeModel implements PayType {
	readonly id: number;
	name: string;
	isActive: boolean = true;

	constructor(epicType: PayType) {
		makeAutoObservable(this);
		this.id = epicType.id;
		this.name = epicType.name;
		this.isActive = epicType.isActive ?? true;
	}
	get canSave() {
		return Boolean(this.name.trim());
	}
	setName(name: string) {
		this.name = name;
	}
}